const aboutData = [
  {
    id: 0,
    info_0:
      "Before coding, I volunteered as a soccer coach and tech support intern at a local school. In 2022, I took a leap and trained in modern app development at udemy.",
    info_1:
      "Hi, I am Aditya, a self taught frontend developer. My goal is to become a software engineer and build scalable, interactive web apps.",
    info_2:
      "My development environment consist of vscode, chrome, github and a sprinkle of coffee beans when needed.",
    info_3:
      "When i am not on the computer, you can find me in the gym or running tracks.",
  },
];

const skillsData = [
  {
    id: 0,
    title: "Language",
    info: "html/css, javascript",
  },
  {
    id: 2,
    title: "Framework",
    info: "react js, tailwind css",
  },
  {
    id: 3,
    title: "others",
    info: "excel, word, solidworks, git",
  },
];

export {aboutData, skillsData}